export default "__VITE_ASSET__DE96tXhL__"